import { STATUS_ACTION_TYPES } from './constants';
import { truncate } from 'lodash';

/**
 * @desc
 * @param object: {fieldName:string, fieldLength:number, attributeName:string}
 * @returns string - truncated fieldName || fieldName
 */
export const truncateModalFields = ({
	fieldName = '',
	fieldLength = 28,
	attributeName = '',
}) => {
	if (typeof fieldName !== 'string') return;

	if (attributeName) {
		if (typeof fieldName === 'string' && fieldName.length > fieldLength)
			return fieldName;
		return '';
	}
	return fieldName.length > fieldLength
		? truncate(fieldName, { length: fieldLength })
		: fieldName;
};

export const truncateModalFieldByWord = ({
	individualWordLength = 15,
	fieldLength = null,
	fieldValue = '',
}) => {
	const wordArray = fieldValue.split(' ');
	for (let i = 0; i < wordArray.length; i++) {
		wordArray[i] =
			wordArray[i].length > individualWordLength
				? truncate(wordArray[i], { length: individualWordLength })
				: wordArray[i];
	}
	const individuallyTruncatedFieldValue = wordArray.join(' ');

	if (!fieldLength) {
		return individuallyTruncatedFieldValue;
	}

	return individuallyTruncatedFieldValue.length > fieldLength
		? truncate(individuallyTruncatedFieldValue, { length: fieldLength })
		: individuallyTruncatedFieldValue;
};

export const formattedPhoneNumber = (phoneNumber) => {
	return phoneNumber
		? `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
				3,
				6,
		  )}-${phoneNumber.slice(6)}`
		: '';
};

export const scrollToTop = () => {
	window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
};

export const getPercentageValue = (value) => {
	return !Number.isNaN(value) ? `${value}%` : value;
};

export const getFormattedCurrency = (value) => {
	return !Number.isNaN(value)
		? `$${Math.round(value).toLocaleString()}`
		: value;
};

export const getAlertTypeId = (alertTypes, alert) => {
	return alertTypes.find((obj) => obj.desc === alert).id;
};

export const roundToHundredth = (value) => {
	return !Number.isNaN(value) ? Math.ceil(value * 100) / 100 : '';
};

export const getInitials = (firstName, lastName) =>
	`${firstName.charAt(0)}${lastName.charAt(0)}`;

export const getDateString = (date) =>
	date ? new Date(date).toLocaleDateString('en-US') : null;

export const disableAllQuickActions = (quickActions) => {
	if (quickActions) {
		quickActions.forEach((item) => {
			item.forEach((option) => {
				option.disabled = true;
				option.iconColor = 'gray';
			});
		});
	}
};

/**
 * Returns Alerts Quick Actions object
 * @param {boolean} showViewActions Show View action (ie View Alert, View Contact)
 * @param {any} ownerId This alert's ownerId/contactId
 * @param {any} statusId This alert's statusId
 * @param {boolean} mainProfileIsInternalUser
 * @param {boolean} isImpersonated
 * @param {boolean} loggedInUserId
 * @param {boolean} isLoanAlert
 * @param {string} easeUrl
 * @param {boolean} isUwmLoan
 * @param {string} alertType
 */
export const getAlertQuickActions = (
	showViewActions,
	ownerId,
	statusId,
	mainProfileIsInternalUser,
	isImpersonated,
	loggedInUserId,
	isLoanAlert,
	easeUrl,
	isUwmLoan,
	alertType,
) => {
	const alertStatusUnchangeable =
		statusId === STATUS_ACTION_TYPES.DONE_FOR_YOU ||
		statusId === STATUS_ACTION_TYPES.SCHEDULED;
	const menu = [
		[
			{
				icon: ['far', 'envelope-open-text'],
				text: 'Send Email',
				action: 'sendEmail',
				disabled: mainProfileIsInternalUser,
			},
			{
				icon: ['far', 'sticky-note'],
				text: 'Add Note',
				action: 'addNote',
				disabled: mainProfileIsInternalUser,
			},
			{
				icon: ['far', 'file-import'],
				text: 'Send to Blink+',
				action: 'sendToBlink',
				disabled:
					isImpersonated ||
					mainProfileIsInternalUser ||
					loggedInUserId !== ownerId,
			},
		],
		[
			{
				icon: ['far', 'circle'],
				text: 'Mark as To-Do',
				status: 'To-Do',
				action: 'markAsToDo',
				disabled: mainProfileIsInternalUser || alertStatusUnchangeable,
			},
			{
				icon: ['far', 'check-circle'],
				text: 'Mark as Done',
				status: 'Done',
				action: 'markAsDone',
				disabled: mainProfileIsInternalUser || alertStatusUnchangeable,
			},
			{
				icon: ['far', 'times-circle'],
				text: 'Mark as Dismissed',
				status: 'Dismissed',
				action: 'markAsDismissed',
				disabled:
					mainProfileIsInternalUser ||
					(alertStatusUnchangeable && alertType !== 'Review Me'),
			},
		],
	];

	if (showViewActions) {
		// Add View actions to start of menu
		menu.unshift([
			{
				icon: ['far', 'bell'],
				text: 'View Alert',
				action: 'viewAlert',
			},
			{
				icon: ['far', 'user'],
				text: 'View Contact',
				action: 'viewContact',
			},
		]);
	}

	// Adds View in Ease as the last option to the specific set of menu options
	if (isLoanAlert) {
		menu[0].push({
			icon: ['far', 'external-link-alt'],
			text: 'View in EASE',
			action: 'viewInEase',
			disabled: !isUwmLoan || !easeUrl,
		});
	}

	return menu;
};

export const openInEase = (url) => window.open(url, '_blank');
